import { render, staticRenderFns } from "./Kabinet.vue?vue&type=template&id=8ee3b5a8&scoped=true&"
import script from "./Kabinet.vue?vue&type=script&lang=js&"
export * from "./Kabinet.vue?vue&type=script&lang=js&"
import style0 from "./Kabinet.vue?vue&type=style&index=0&id=8ee3b5a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee3b5a8",
  null
  
)

export default component.exports